import React, { useEffect, useState } from "react";
import { Outlet } from "react-router-dom";
import { Dummy } from "./Dummy";
import { DummyAfterLogin } from "./DummyAfterLogin";
import { fetchToken } from "../../../../features/common/FetchCookie";

const DummyPage = () => {
  const [isLogin, setIsLogin] = useState(null); // null = loading state

  useEffect(() => {
    const fetchingToken = async () => {
      const token = await fetchToken();
      setIsLogin(!!token);
    };
    fetchingToken();
  }, []);

  // Show nothing while checking authentication
  if (isLogin === null) {
    return null; // Or show a spinner
  }

  // Remove the wrapping div - render fragments instead
  return (
    <>
      {isLogin ? (
        <>
          <div className="sticky top-0 z-[60]">
            <DummyAfterLogin />
          </div>
          <Outlet />
        </>
      ) : (
        <Dummy />
      )}
    </>
  );
};

export default DummyPage;
